module.exports = __webpack_public_path__ + "img/cta-logo.6f8bd4f1.png";